<script setup lang="ts">
import { ref } from 'vue'
import { useTranslation } from 'i18next-vue'

interface Props {
  name: string
  mobile: string
  email: string | null
  disableName?: boolean
  disableMobile?: boolean
  disableEmail?: boolean
  mobileValidator: (val: string) => boolean
  emailValidator: (val: string) => boolean
}

interface Emits {
  (e: 'update:name', value: string): void
  (e: 'update:mobile', value: string): void
  (e: 'update:email', value: string): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()
const { t } = useTranslation()

const showNumpad = ref(false)

const nameModel = ref(props.name)
const mobileModel = ref(props.mobile)
const emailModel = ref(props.email)

const updateName = (value: string) => {
  nameModel.value = value
  emit('update:name', value)
}

const updateMobile = (value: string) => {
  mobileModel.value = value
  emit('update:mobile', value)
}

const updateEmail = (value: string) => {
  emailModel.value = value
  emit('update:email', value)
}
</script>

<template>
  <van-cell-group class="group-container" inset>
    <van-field
      style="padding-top: 10px; padding-bottom: 10px"
      :model-value="name"
      @update:model-value="updateName"
      :required="!disableName"
      :label="t('appointmentrequest.name')"
      :placeholder="t('appointmentrequest.name_placeholder')"
      :disabled="disableName"
      :rules="[{ required: true, message: t('appointmentrequest.name_require') }]"
    />
    <van-field
      :model-value="mobile"
      @update:model-value="updateMobile"
      :required="!disableMobile"
      :label="t('appointmentrequest.phone_number')"
      :placeholder="t('appointmentrequest.phone_number_placeholder')"
      :disabled="disableMobile"
      readonly
      clickable
      @touchstart.stop="disableMobile ? (showNumpad = false) : (showNumpad = true)"
      :rules="[
        {
          required: true,
          message: t('appointmentrequest.phone_number_require'),
        },
        {
          validator: mobileValidator,
          message: t('appointmentrequest.phone_number_require'),
        },
      ]"
    />
    <!-- <van-field
      :model-value="email"
      @update:model-value="updateEmail"
      type="email"
      :label="t('appointmentrequest.email')"
      :disabled="disableEmail"
      :placeholder="t('appointmentrequest.email_placeholder')"
      :rules="[
        {
          validator: emailValidator,
          message: t('appointmentrequest.email_validate'),
        },
      ]"
      maxlength="255"
    /> -->
    <van-number-keyboard
      :model-value="mobile"
      @update:model-value="updateMobile"
      :show="showNumpad"
      :maxlength="10"
      @blur="showNumpad = false"
    />
  </van-cell-group>
</template>

<style scoped>
.group-container {
  margin: 15px 0px;
  border: 2px solid #c8c9cc;
  border-radius: 20px;
}
</style>
